import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./challanReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useHistory } from "react-router-dom";

let excelData = [];
let excelData2 = [];

function AccountMasterReport({ sessionObject }) {
  const history = useHistory();
  const columns = React.useMemo(
    () => [
      {
        Header: "Company name",
        accessor: "name",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Gst no",
        accessor: "gst",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      // {
      //   Header: "Pan no",
      //   accessor: "",
      //   width: "100px",
      //   minWidth: "10px",
      //   canFilter: true,
      // },
      {
        Header: "Cst no",
        accessor: "cst_no",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Tin no",
        accessor: "tin_no",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Bill name",
        accessor: "bill_name",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Bill gst no",
        accessor: "bill_gst",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Addresss",
        accessor: "address",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "City",
        accessor: "city",
        canFilter: true,
      },
      // {
      //   Header: "Pincode",
      //   accessor: "",
      //   canFilter: true,
      // },
      {
        Header: "Delivery address",
        accessor: "delivery_address",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Contact person",
        accessor: "contact_person",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Mobile no",
        accessor: "mobile",
        canFilter: true,
      },
      // {
      //   Header: "Phone office",
      //   accessor: "",
      //   canFilter: true,
      // },
      // {
      //   Header: "Phone residence",
      //   accessor: "",
      //   canFilter: true,
      // },
      {
        Header: "Email id",
        accessor: "email",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        canFilter: true,
      },
      {
        Header: "Bitlty charge",
        accessor: "bilty_charge",
        canFilter: true,
      },
      {
        Header: "Hamali charge",
        accessor: "hamali_charge",
        canFilter: true,
      },
      {
        Header: "Door delivery charge",
        accessor: "door_delivery_charge",
        canFilter: true,
      },
      {
        Header: "Collection charge",
        accessor: "collection_charge",
        canFilter: true,
      },
      {
        Header: "Collection charge unit",
        accessor: "collection_charge_unit",
        canFilter: true,
      },
      {
        Header: "Commsision rate",
        accessor: "commission_rate",
        canFilter: true,
      },
      {
        Header: "Ac knowledgemenet",
        accessor: "acknowledgement",
        canFilter: true,
      },
      {
        Header: "Limit amount",
        accessor: "limit_amt",
        canFilter: true,
      },
      // {
      //   Header: "Only pod bill",
      //   accessor: "",
      //   canFilter: true,
      // },
      {
        Header: "Automatic billing",
        accessor: "automatic_billing",
        canFilter: true,
      },
      {
        Header: "Is active",
        accessor: "is_active",
        canFilter: true,
      },
      {
        Header: "Is door delivery",
        accessor: "is_door_delivery",
        canFilter: true,
      },
      {
        Header: "Is account related",
        accessor: "is_account_related",
        canFilter: true,
      },
      {
        Header: "Is daily mail",
        accessor: "is_daily_mail",
        canFilter: true,
      },
      {
        Header: "Is transporter",
        accessor: "is_transporter",
        canFilter: true,
      },
      {
        Header: "Auto pod statement",
        accessor: "auto_pod_statement",
        canFilter: true,
      },
      {
        Header: "Group",
        accessor: "",
        canFilter: true,
      },
      {
        Header: "Subgroup",
        accessor: "",
        canFilter: true,
      },
      {
        Header: "Parent company",
        accessor: "",
        canFilter: true,
      },
    ],
    []
  );

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const fetchIdRef = React.useRef(0);
  let download_ref = React.useRef(null);
  const [dateState, setDateState] = React.useState({
    date_from: new Date(),
    date_to: new Date(),
    pending_trip: "2",
    all_branch: "Y",
  });
  const [finalInput, setFinalInput] = React.useState({});
  const [pageState, setPageState] = React.useState({
    total_amount: 0,
    total_weight: 0,
    total_pkgs: 0,
    total_bilties: 0,
  });

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      const fetchId = ++fetchIdRef.current;
      setLoading(true);

      let newObject = {};
      if (fetchId === fetchIdRef.current) {

        if (dateObject.pending_trip == "1") {
          newObject.pending_trip = String(1);
        }
        if (dateObject.all_branch == "N") {
          newObject.created_from = String(
            sessionObject.sessionVariables.branch_id
          );
        }

        newObject = { ...newObject, ...customFilters };

        let inputData = {
          paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
          sort_fields: sortBy,
          filter_fields: newObject,
          date_dict: {
            date_from: dateObject.date_from,
            date_to: dateObject.date_to,
          },
        };

        setFinalInput(inputData);
        let response = await fetch(SERVER_URL + "/report/accounts_report", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(inputData),
        });
        let resp = await response.json();
        // let setObj = {};
        if (fetchId == fetchIdRef.current) {
          setPageCount(Math.ceil(resp / pageSize));
          setData(resp["data"]);
          // if (resp["data"] && "total_rows" in resp) {
          //   setObj = {
          //     total_weight: resp["total_weight"],
          //     total_pkgs: resp["total_pkgs"],
          //     total_memo: resp["total_rows"],
          //   };
          //   setPageState({ ...pageState, ...setObj });
          // }
          setLoading(false);
        }
      }
    },
    []
  );

  const handleViewClick = (cell) => {
    history.push("/account_master", cell[0].value);
  };

  return (
    <div className="report-challan">
      <div className="form-header">Account Master Report</div>

      <div className="report-challan-table-container">
        {/* <div className="report-field-row">
          <div>
            From Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_from}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_from"]: date,
                })
              }
            />
          </div>
        </div> */}

        <ReportTable
          columns={columns}
          data={data}
          fetchData={fetchData}
          dateObject={dateState}
          loading={loading}
          pageCount={pageCount}
          canView={true}
          handleViewClick={handleViewClick}
        />
      </div>
      {/* <div className="form-footer">
        <button style={{ display: "none" }}>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="btn btn-primary"
            // table="challan_report_excel"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Download as XLS"
            ref={(a) => (download_ref.current = a)}
          />
        </button>
        <button
          className="btn btn-primary"
          onClick={async () => {
            setLoading(true);

            let inputData = {
              sort_fields: finalInput.sort_fields,
              filter_fields: finalInput.filter_fields,
              date_dict: finalInput.date_dict,
            };

            let url = "/report/challan_with_grouping"

            let response = await fetch(SERVER_URL + url, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(inputData),
            });

            let resp = await response.json();

            excelData = resp.data;
            excelData2 = resp.challan_summary;
            setLoading(false);
            download_ref.current.handleDownload();
          }}
        >
          Download as XLS
        </button>
        {ReportExcel.challan_report_excel(excelData, excelData2, dateState)}
      </div> */}
    </div>
  );
}

export default AccountMasterReport;
